function toggleEditDirective($document) {
    'ngInject';

    return {
        restrict: 'AE',
        link(scope, element, attr) {
            scope.editing = false;
            element.on('dblclick', (event) => {
                    return scope.$apply(() => scope.editing = true);
                }
            );

            $document.on('click', () => {
                    if (!element.is(':hover')) {
                        return scope.$apply(() => scope.editing = false);
                    }
                }
            );

            return true;
        }
    };
}

angular
    .module('BB')
    .directive('bbToggleEdit', toggleEditDirective);



// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/toggle-edit/toggle_edit.directive.js